import React, { useEffect, useRef, useState } from "react"
import { webLoadingFalse, webLoadingTrue, webNavigate } from '../../services/navigate.service';
import SearchIcon from "../../images/SearchIcon";
import PlusIcon from "../../images/PlusIcon";
import { extractValues, updateUrlParams, validateNoSpecialCharsOrSpaces } from "../../validation/ValidationInput";
import { getListReasons } from "../../services/reason.service";
import CorrectionIcon from "../../images/CorrectionIcon";
import CountIcon from "../../images/CountIcon";
import TransferIcon from "../../images/TransferIcon";
import RefundsIcon from "../../images/RefundsIcon";
import VoidsIcon from "../../images/VoidsIcon";
import SalesCancelIcon from "../../images/SalesCancelIcon";
import ArrowRightIcon from "../../images/ArrowRightIcon";
import { useResponsive } from "../../hook/useResponsive";
import CountReasonIcon from "../../images/CountReasonIcon";
import TransferRefundIcon from "../../images/TransferRefundIcon";

const reasonsType: { [key: number]: string } = {
    1: "Corrections",
    2: "Counts",
    3: "Transfers",
    4: "Refunds",
    5: "Voids",
    6: "Sale Cancellation",
};
interface Reason {
    reasonType: number;
    records: number;
}
interface ReasonsResponse {
    data: {
        data: {
            reasons: {
                reasonType: number;
                records: number;
            }[];
            count: number
        }
    }

}
const Reasons = () => {
    const preLanguage = localStorage.getItem("language");
    const initalFilter = {
        page: 1,
        limit: 50,
        searchValue: "",
        sort: "DESC"
    }
    const searchInputRef = useRef<HTMLInputElement | null>(null);
    const [language, setLanguage] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const { isMobile, getWidth } = useResponsive();
    const companyId: string = localStorage.getItem("companyId") || "";
    const [filter, setFilter] = useState<any>(initalFilter)
    const [termsArray, setTermsArray] = useState<Reason[]>([]);

    const handleKeyDown = (event: KeyboardEvent) => {
        if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
            event.preventDefault();
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, []);
    useEffect(() => {
        if (window.languageContext) {
            setLanguage(window.languageContext.language);
        }
    }, [window, window.languageContext]);
    const getStatus = (reasonType: string) => {
        const listStatus = [
            { id: 1, name: 'Corrections', image: <CorrectionIcon /> },
            { id: 2, name: 'Counts', image: <CountReasonIcon /> },
            { id: 3, name: 'Transfers', image: <TransferRefundIcon /> },
            { id: 4, name: 'Refunds', image: <RefundsIcon /> },
            { id: 5, name: 'Voids', image: <VoidsIcon /> },
            { id: 6, name: 'Sale Cancellation', image: <SalesCancelIcon /> },
        ]
        return listStatus.filter((v) => v.name === reasonType)[0].image
    }
    const getListDataAttributes = async (val: any) => {
        setLoading(true);
        webLoadingFalse();
        try {
            const response: ReasonsResponse = await getListReasons(companyId, val.page, val.limit,);
            setTermsArray(response.data.data.reasons);
        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        const filterParams: any = extractValues(location.search.split("&"));
        const data: any = {
            searchValue: filterParams.search ? filterParams.search : filter.searchValue,
            page: filterParams.page ? filterParams.page : filter.page,
            limit: filterParams.limit ? filterParams.limit : filter.limit,
        }
        setFilter((prevFilter: any) => ({
            ...prevFilter,
            searchValue: filterParams.search || prevFilter.searchValue,
            page: +filterParams.page || prevFilter.page,
            limit: +filterParams.limit || prevFilter.limit,
        }));
        getListDataAttributes(data)
        const handleNewToken = () => {
            getListDataAttributes(data);
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, [location]);

    const handleSubmitSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            const updatedFilter = { ...filter };
            const url = updateUrlParams(updatedFilter);
            webNavigate(url);
            setTermsArray((prev: any) => {
                if (!filter.searchValue) return prev;
                return prev.filter((v: any) => v.records === filter.searchValue);
            });
        }
    };

    return (
        <div className="h-full relative" style={{ overflowY: isMobile ? "auto" : undefined, paddingBottom: isMobile ? "24px" : undefined }} >
            <div className="">
                <div className="space-y-2" >
                    <p
                        style={{ color: '#222525' }}
                        className="text-[24px] leading-[130%] font-medium font-inter"
                    >
                        {language && language?.['Reasons'] ? language?.['Reasons'] : 'Reasons'}
                    </p>
                    <p
                        style={{ color: '#6A7878' }}
                        className="text-[14px] leading-[130%] font-inter"
                    >Use this section to manage stock change reasons like corrections, counts, transfers, <br />
                        and refunds to keep inventory tracking and reporting accurate.</p>
                </div>
            </div>
            <div className="flex items-center flex-wrap" style={{ marginTop: '20px', gap: '20px' }}>
                {termsArray.length > 0 && termsArray.map((val) => {
                    return (
                        <div onClick={() => { webNavigate("/" + preLanguage + `/reasons/${companyId}/${val.reasonType}`) }} className="space-y-1 cursor-pointer" style={{ width: getWidth('32%', '100%'), border: '1px solid #EBF0F0', backgroundColor: '#FFFFFF', padding: getWidth('20px 12px', '20px 24px'), borderRadius: 16 }}>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                    <div className="flex items-center justify-center" style={{ width: '40px', height: "40px", borderRadius: "10px", backgroundColor: '#F3F3F3' }}>
                                        {getStatus(reasonsType[val.reasonType])}
                                    </div>
                                    <div className="space-y-1">
                                        <p style={{ fontSize: "16px", lineHeight: '20px', fontWeight: 500, color: '#222525' }}>{language?.[reasonsType[val.reasonType]] ?? reasonsType[val.reasonType]}</p>
                                        <p style={{ fontSize: "14px", lineHeight: '18px', fontWeight: 400, color: '#4A5353' }}>{val.records}</p>
                                    </div>
                                </div>
                                <div className="flex items-center justify-center" style={{ width: '24px', height: "24px", }}>
                                    <ArrowRightIcon />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
};

export default Reasons;